/* eslint-disable import/prefer-default-export */
import { isBuyerCreditState } from "@pd/layouts/BuyerCredit/types";
import { createSelector } from "@reduxjs/toolkit";

export const isBuyerCredit = createSelector(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (state: any) => isBuyerCreditState(state),
  (isBuyerCredState): boolean => isBuyerCredState,
);
